import { render } from "./addDataList.vue?vue&type=template&id=0afcb311&scoped=true"
import script from "./addDataList.vue?vue&type=script&lang=js"
export * from "./addDataList.vue?vue&type=script&lang=js"

import "./addDataList.vue?vue&type=style&index=0&id=0afcb311&lang=scss&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afcb311"]])

export default __exports__